import SEO from './SEO';

const HomeSEO = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "NABAZAT AL QALB",
    "description": "Leading medical supplies and healthcare solutions provider in Erbil, Iraq",
    "url": "https://nabazatalqalb.com",
    "logo": "https://nabazatalqalb.com/logo512.png",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Erbil",
      "addressRegion": "Arbil",
      "addressCountry": "IQ"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["English", "Arabic", "Kurdish"]
    },
    "sameAs": [
      "https://facebook.com/nabazatalqalb",
      "https://twitter.com/nabazatalqalb",
      "https://linkedin.com/company/nabazatalqalb"
    ],
    "areaServed": {
      "@type": "Country",
      "name": "Iraq"
    },
    "serviceType": "Medical Supplies and Healthcare Solutions",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Medical Supplies Catalog",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "MedicalDevice",
            "name": "Medical Equipment"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Drug",
            "name": "Pharmaceuticals"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "MedicalDevice",
            "name": "Healthcare Solutions"
          }
        }
      ]
    }
  };

  return (
    <SEO
      title=""
      description="NABAZAT AL QALB is the premier medical supplies company in Erbil, Iraq. We provide high-quality medical equipment, pharmaceuticals, and comprehensive healthcare solutions to hospitals, clinics, and healthcare professionals across Iraq. Trusted by leading medical institutions."
      keywords="medical supplies Erbil Iraq, healthcare equipment, pharmaceuticals, medical devices, hospital supplies, clinic equipment, medical solutions, healthcare providers Iraq, medical equipment suppliers, NABAZAT AL QALB"
      url="https://nabazatalqalb.com"
      structuredData={structuredData}
    />
  );
};

export default HomeSEO; 